import * as Sentry from "@sentry/nextjs";
import { ProtocolError, type ServerMessage } from "./protocol";
import { topicId, type Topic } from "./types";

export function captureStreamError(reason: string, topic: Topic | null, extra?: Record<string, unknown>, tags?: Record<string, string>): void {
  Sentry.captureMessage("Odds screen stream client error", {
    level: "error",
    tags: { odds_screen_stream: reason, odds_screen_topic: topic?.kind ?? "none", ...tags },
    ...(extra && { extra }),
  });
}

export function rejectedRowsExtra(message: Extract<ServerMessage, { type: "snap" | "delta" }>): Record<string, unknown> | null {
  if (!("rejected" in message.payload) || message.payload.rejected.length === 0) return null;
  const { rejected } = message.payload;
  return { topic: topicId(message.topic), rejected: rejected.length, first: rejected[0] };
}

export function invalidMessageTags(error: unknown, data: unknown, length: number, authed: boolean): Record<string, string> {
  const thrown = error instanceof ProtocolError && error.cause !== undefined ? error.cause : error;
  return {
    odds_screen_error: thrown instanceof Error ? thrown.name : typeof thrown,
    odds_screen_error_message: (thrown instanceof Error ? thrown.message : String(thrown)).slice(0, 200),
    odds_screen_data: typeof data,
    odds_screen_length: String(length),
    odds_screen_authed: String(authed),
  };
}
